import { translate, type Locale, type TranslationKey } from './translations';

const criterionOrder = [
  'reliability',
  'communication',
  'professionalism',
  'quality',
  'safety',
  'experience',
  'relaxation'
];

const criterionTranslationKeys: Record<string, TranslationKey> = {
  reliability: 'review.criteria.reliability',
  communication: 'review.criteria.communication',
  professionalism: 'review.criteria.professionalism',
  quality: 'review.criteria.quality',
  safety: 'review.criteria.safety',
  experience: 'review.criteria.experience',
  relaxation: 'review.criteria.relaxation'
};

/** Übersetzt einen stabilen Kriteriencode, ohne den gespeicherten Review-Wert zu verändern. */
export function reviewCriterionLabel(code: string, locale: Locale): string {
  const key = criterionTranslationKeys[code];
  return key ? translate(locale, key) : code;
}

/** Liefert Kriterien in einer stabilen fachlichen Reihenfolge. */
export function reviewCriterionEntries(criteria: Record<string, number>): Array<[string, number]> {
  return Object.entries(criteria).sort(([left], [right]) => {
    const leftIndex = criterionOrder.indexOf(left);
    const rightIndex = criterionOrder.indexOf(right);
    return (leftIndex < 0 ? criterionOrder.length : leftIndex) - (rightIndex < 0 ? criterionOrder.length : rightIndex);
  });
}
